import React, { useEffect, useRef, useState } from 'react';
import { useForm } from 'react-hook-form';
import { ADMIN_TABS_CONFIGURATION } from '../../constants/QuestionBankConstants';
import { getInstutueApp } from '../api-integration-util';
import JoditEditor from 'jodit-react';

// Module-scope so the object identity is stable. jodit-react destroys and re-creates
// the editor whenever the `config` prop's identity changes (useEffect(..., [config])),
// so an inline literal tore the editor down on every render of this component - which
// also killed any image dialog that happened to be open.
const DESCRIPTION_JODIT_CONFIG = {
  readonly: false,
  enableDragAndDropFileToEditor: true,
  uploader: {
    insertImageAsBase64URI: true,
    // Jodit's default list is ['jpg','png','jpeg','gif']; anything else silently
    // falls through to a POST at the (empty) uploader.url.
    imagesExtensions: ['jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp'],
  },
  height: 200,
};

export default function DynamicInput(props: any) {
  const { register, handleSubmit, watch, errors, reset, setValue } = useForm({
    mode: 'onChange',
    reValidateMode: 'onSubmit',
    validateCriteriaMode: 'all',
  });
  const [descriptionValue,setDescriptionValue] = useState('');
  const [htmlDescriptionValue,setDescriptionHtmlValue] = useState('');
  
  const editor = useRef(null);
  useEffect(() => {
    // @ts-ignore: Object is possibly 'null'.
    document && document.getElementById('resetAllId') && document.getElementById('resetAllId').click();
  }, [props?.tabName, props?.formReset === true]);

  const resetAllFieldsData = () => {
    if(ADMIN_TABS_CONFIGURATION && props && props.tabName) {
      ADMIN_TABS_CONFIGURATION[props?.tabName].inputs.filter((i) => {
        if (i.inputType === 'select' || i.inputType === 'multi-select') {
          setValue(i.name, '');
        }
      });
    }
    reset();
  };

  const onSave = (data: any) => {
    if (errors && Object.keys(errors)?.length > 0 && process && process.exit) {
      process.exit(1);
    } else {
      props.OutputEvent(
        data,
        ADMIN_TABS_CONFIGURATION?.[props?.tabName]?.['info']
      );
    }
  };

  const onDelete = (data: any) => {
      props.OutputEvent(
        data,
        ADMIN_TABS_CONFIGURATION?.[props?.tabName]?.['delete']
      );
  };

  const onChangeSelect = (e) =>{
    // setDescriptionValue(e.target.value)
    const path = 'library/getBatchDescription'
    getInstutueApp(`${path}/${e.target.value}`, {})
      .then((res: any) => {
        if(res){
          setDescriptionValue(res.result || '')
        }
      })
      .catch((e) => {
        alert(e)
      });
  }

  const getCurrentDate = () => {
    return new Date().toISOString().slice(0, 10);
  };
  return (
    <div className='background-common-div'>
      <div className='btn-div'>
        <div style={{float: 'right'}}>
          <input
            className='btn-common'
            onClick={handleSubmit(onSave)}
            type='button'
            value='Save'
          />
          {
            props?.tabName !== 'BATCH_DESCRIPTION' && (
            
              <input
                className='btn-common'
                onClick={onDelete}
                type='button'
                value='Delete'
              />
            )
          }
          <input
                id='resetAllId'
                className='btn-common'
                onClick={(e) => resetAllFieldsData()}
                type='button'
                value='Reset'
              />
          
        </div>
      </div>
      <div className='common-div'>
        <form>
          <div className='row'>
            <div className='col-xs-12 col-sm-12 col-md-12 col-lg-12'>
              {ADMIN_TABS_CONFIGURATION?.[props?.tabName]?.inputs.map(
                (i: any) => (
                  <div className='form-sub-div'>
                    <label className='form-label'>
                      {i.labelName}
                      {i.isMandatory === 'Y' && <span> *</span>}
                    </label>
                    <div className='form-elements'>
                      {(i.inputType === 'text' ||
                        i.inputType === 'email' ||
                        i.inputType === 'password') && (
                        <input
                          className='form-details'
                          type={i.inputType}
                          placeholder={i.labelName}
                          name={i.name}
                          autoComplete='new-password'
                          ref={register({
                            required: i?.isMandatory === 'Y' ? true : false,
                            validate: (value) =>
                              i?.validateWithExistingData === 'Y'
                                ? !props?.config?.[i?.existingDataSetKey]
                                    ?.map((e: any) =>
                                      e?.[i?.name]?.toUpperCase()
                                    )
                                    ?.includes(value.toUpperCase())
                                : true,
                            pattern:
                              i?.validatePattern === 'Y' ? i?.pattern : '',
                          })}
                        />
                      )}
                      {(i.inputType === 'textarea') && (
                        <>
                        <JoditEditor
                        ref={editor}
                        value={descriptionValue}
                        config={DESCRIPTION_JODIT_CONFIG}
                        onBlur={(e:any) => {
                          setDescriptionHtmlValue(e?.target?.innerHTML || e);
                        }}
                        onChange={(newContent) => {}}
                      />
                        
                        <textarea
                          style={{opacity:0}}
                          placeholder={i.labelName}
                          name={i.name}
                          autoComplete='batch'
                          value={htmlDescriptionValue}
                          ref={register({
                            required: i?.isMandatory === 'Y' ? true : false,
                            validate: (value) =>
                              i?.validateWithExistingData === 'Y'
                                ? !props?.config?.[i?.existingDataSetKey]
                                    ?.map((e: any) =>
                                      e?.[i?.name]?.toUpperCase()
                                    )
                                    ?.includes(value.toUpperCase())
                                : true,
                            pattern:
                              i?.validatePattern === 'Y' ? i?.pattern : '',
                          })}
                        />
                        </>
                      )}
                      {i.inputType === 'date' && (
                      <input
                        className='form-details'
                        type={i.inputType}
                        placeholder={i.labelName}
                        name={i.name}
                        {...(i.excludeMinValue ? {} : { min: i.minDateValue ? watch(i.minDateValue) : getCurrentDate() })}
                        ref={register({
                          required: i?.isMandatory === 'Y' ? true : false,
                          ...(i.excludeMinValue
                            ? {}
                            : {
                                validate: (value) =>
                                  watch(i.name) || i.minDateValue
                                    ? i.minDateValue && watch(i.minDateValue) !== ''
                                      ? value !== '' && value > watch(i.minDateValue)
                                      : i.minDateValue
                                      ? true
                                      : value > getCurrentDate()
                                    : true,
                              }),
                        })}
                      />
                    )}
                      {i.inputType === 'select' && (
                        <select
                          className='form-details'
                          name={i?.name}
                          defaultValue=''
                          onChange={onChangeSelect}
                          ref={register({
                            validate: (value) => value !== '',
                          })}
                        >
                          <option disabled value=''>
                            Please Select {i.labelName}
                          </option>
                          {props?.config?.[i?.values]?.map((ele: any) => (
                            <option
                              key={ele?.[i?.optionKey]}
                              value={ele?.[i?.optionKey]}
                            >
                              {ele?.[i?.optionValue]}
                            </option>
                          ))}
                        </select>
                      )}
                      {i.inputType === 'multi-select' && (
                        <select
                          multiple
                          className='form-details'
                          name={i?.name}
                          ref={register({
                          })}
                        >
                          <option disabled value=''>
                            Please Select {i.labelName}
                          </option>
                          {props?.config?.[i?.values]?.map((ele: any) => (
                            <option
                              key={ele?.[i?.optionKey]}
                              value={ele?.[i?.optionKey]}
                            >
                              {ele?.[i?.optionValue]}
                            </option>
                          ))}
                        </select>
                      )}
                    </div>
                  </div>
                )
              )}
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}
